import { FirebaseServices } from "./config";
import { callFunction } from "./helpers";
import {
  CreateWorkflowRequest,
  CreateWorkflowResponse,
  ActionTaskRequest,
  StandardResponse,
  GetMyWorkflowsRequest,
  GetMyWorkflowsResponse,
  GetAllWorkflowsRequest,
  GetAllWorkflowsResponse,
} from "common247";

/**
 * Creates a new state-machine driven workflow associated with a memory.
 * @param fb - The Firebase services instance.
 * @param request - The request payload to create a workflow.
 * @returns A promise resolving to the CreateWorkflowResponse.
 */
export async function createWorkflow(fb: FirebaseServices, request: CreateWorkflowRequest): Promise<CreateWorkflowResponse> {
  const result = await callFunction(fb, "createWorkflowFunc", request);
  return result as CreateWorkflowResponse;
}

/**
 * Executes an action (Accept/Reject) on an active review or revision task.
 * @param fb - The Firebase services instance.
 * @param request - The request payload containing the task ID and action.
 * @returns A promise resolving to the StandardResponse.
 */
export async function actionTask(fb: FirebaseServices, request: ActionTaskRequest): Promise<StandardResponse> {
  const result = await callFunction(fb, "actionTaskFunc", request);
  return result as StandardResponse;
}

/**
 * Retrieves all workflows owned by the user, and all active/pending tasks assigned to the user.
 * @param fb - The Firebase services instance.
 * @param request - The request payload (typically empty, as authentication uid is used).
 * @returns A promise resolving to the GetMyWorkflowsResponse.
 */
export async function getMyWorkflows(fb: FirebaseServices, request: GetMyWorkflowsRequest): Promise<GetMyWorkflowsResponse> {
  const result = await callFunction(fb, "getMyWorkflowsFunc", request);
  return result as GetMyWorkflowsResponse;
}

/**
 * Retrieves all workflow instances and tasks in the platform for administrators.
 * @param fb - The Firebase services instance.
 * @param request - Optional request payload.
 * @returns A promise resolving to the GetAllWorkflowsResponse.
 */
export async function getAllWorkflows(fb: FirebaseServices, request: GetAllWorkflowsRequest = {}): Promise<GetAllWorkflowsResponse> {
  const result = await callFunction(fb, "getAllWorkflowsFunc", request);
  return result as GetAllWorkflowsResponse;
}

